import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

import { AUTH_CONFIG, AUTH_DEFAULTS, type AuthConfig } from '../session/auth.config';
import { authInterceptor } from './auth.interceptor';

/**
 * The single entry an app adds to opt into `@sisoma/auth`'s HTTP layer. Wires
 * `HttpClient` with {@link authInterceptor} (cookie credentials, active-partner
 * header, single-flight refresh-on-401) and the {@link AUTH_CONFIG} override:
 *
 * ```ts
 * provideAuth({ apiUrl: 'https://api.halio.ai', loginUrl: 'https://app.halio.ai/sign-in' })
 * ```
 *
 * Returns `EnvironmentProviders` so the config and HTTP wiring can only be set
 * at the environment level. An app that needs its own `HttpClient` features can
 * skip this and register {@link authInterceptor} (exported separately) itself.
 */
export function provideAuth(config: Partial<AuthConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_CONFIG, useValue: { ...AUTH_DEFAULTS, ...config } },
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  ]);
}
